import React from "react";

const MATERIALS = [
  "PLA", "PETG", "ABS", "Nylon-CF", "TPU 95A", "SLA Resin",
  "Wood-Fill", "Silk-PLA", "Glow-In-Dark", "Carbon Composite",
];

/** Continuous marquee of material names at the bottom of the hero. */
export default function MaterialsMarquee() {
  return (
    <div className="absolute bottom-0 inset-x-0 border-y border-white/5 bg-[#0A0A0C]/80 backdrop-blur-sm py-3 overflow-hidden">
      <div className="marquee-track whitespace-nowrap flex gap-12 font-mono text-xs text-zinc-500 tracking-[0.2em] uppercase">
        {[0, 1].map((rowIdx) => (
          <div key={`materials-row-${rowIdx}`} className="flex gap-12 shrink-0">
            {MATERIALS.map((m) => (
              <React.Fragment key={`${rowIdx}-${m}`}>
                <span>{m}</span>
                <span>·</span>
              </React.Fragment>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
